module.exports = __webpack_public_path__ + "static/media/JP_AS_EYELASHES02.d70dd21f.jpg";